// extracted by mini-css-extract-plugin
export var textInput = "_j7-0";